module.exports = __webpack_public_path__ + "img/3D Max.ae052dce.png";